
export default {
  props: {
    domNamespace: {
      default () {
        return 'e5Dom'
      }
    }
  }
}
